module.exports = __webpack_public_path__ + "img/violet_014.ea1223f6.png";